import { computed, h, defineComponent } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';
import { SlideLeftTransition } from '@/ui/components/transitions/SlideLeftTransition';
import { directive as ClickOutside } from 'vue-clickaway';
import { SlideRightTransition } from '@/ui/components/transitions/SlideRightTransition';

interface ModalSidePanelProps {
  width?: string | number;
  left?: string | number;
  right?: string | number;
  active: boolean;
}

export const ModalSidePanel = defineComponent<ModalSidePanelProps>({
  name: 'ModalSidePanel',
  directives: {
    // eslint-disable-next-line max-len
    //Type 'import("/private/var/www/lumiform/webapp/node_modules/@types/vue-clickaway/node_modules/vue/types/options").DirectiveOptions'
    // eslint-disable-next-line max-len
    //is not assignable to type 'import("/private/var/www/lumiform/webapp/node_modules/vue/types/options").DirectiveOptions'.
    //legacy, not compatible with Vue typings
    //@ts-ignore
    ClickOutside,
  },
  props: ['width', 'left', 'right', 'active'],
  setup(props: ModalSidePanelProps, context) {
    const styles = computed(() => ({
      width: props.width,
      left: props.left,
      right: props.right,
    }));
    const onClickOutside = (event: MouseEvent) => {
      context.emit('click:outside', event);
    };

    return function render() {
      const animation = props.left !== undefined ? SlideLeftTransition : SlideRightTransition;

      return h(animation, [
        props.active && h('div', {
          class: 'modal-side-panel',
          style: styles.value,
          directives: [
            {
              name: 'ClickOutside',
              value: onClickOutside,
            },
          ],
        }, [
          h('div', { class: 'modal-side-panel__content' }, [
            h(Icon, {
              props: {
                icon: 'times',
                classes: 'modal-side-panel__close-icon',
              },
              nativeOn: {
                click: (event: MouseEvent) => {
                  context.emit('close', event);
                },
              },
            }),
            h('div', { class: 'modal-side-panel__title' }, [
              context.slots.title?.(),
            ]),
            context.slots.default?.(),
          ]),
        ]),
      ]);
    };
  },
});
